import * as TYPES from './types';

const initialState = {
  list: [],
  fetching: false,
  errorMessages: null,
  total: 0,
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case TYPES.GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_REQUEST:
      return { ...state, fetching: true, errorFetching: false };

    case TYPES.DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_ERROR:
    case TYPES.GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_ERROR:
    case TYPES.CREATE_ERRORS:
      return {
        ...state,
        errorMessages: payload,
        isCreated: false,
        fetching: false,
      };
    case TYPES.DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_SUCCESS: {
      const list = [...state.list];
      payload.forEach((o) => {
        const index = list.findIndex((item) => item.id === o.id);
        if (index !== -1) list.splice(index, 1);
      });
      return {
        ...state,
        list,
        fetching: false,
        total: state.total - 1,
      };
    }
    case TYPES.GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        total: payload.total,
        list: [...payload.noValidatedScannedDocuments],
        fetching: false,
      };
    }

    case TYPES.CLEAR_NO_VALIDATED_RC_SCANNED_DOCUMENTS_STATE: {
      return {
        ...state,
        fetching: false,
        errorMessages: null,
      };
    }

    case TYPES.CLEAR_ERRORS: {
      return { ...state, errorMessages: null };
    }

    case TYPES.INIT_REDUCER:
      return {
        ...initialState,
        errorMessages: null,
      };

    default:
      return { ...state };
  }
}
